export default "__VITE_ASSET__CW33flGv__"